<template>
  <div class="nsale_">
    <div class="head">
      <div class="head_ head_1">适配模版：</div>
      <div class="head_ head_2" @click="showTempPicker">
        <div style="margin: 0 10px;">
          {{ tempInfo.tempName }}
        </div>
        <img class="i_img" src="../../../assets/image/nsale/down.png" alt="" />
      </div>
      <div class="head_ head_3" @click="addAccount">开设新账号</div>
    </div>

    <div v-if="column1.length != 0">
      <div class="list_" v-if="list.length != 0">
        <div
          class="item_"
          v-for="(item, index) in list"
          :key="index"
          @click="toPreview(index, item)"
        >
          <div class="item_1">
            <img class="item_1img" :src="item.originalImageUrl" alt="poster" />
            <!-- <div class="saveTip">
              <span>长按可保存海报</span>
            </div> -->
          </div>
          <div class="item_2">
            <img class="item_2img" :src="codeUrl" alt="code" />
            <div class="scale">
              <p class="txt txt1">{{ defaultInfo.name }}</p>
              <p class="txt txt2">{{ defaultDes1 }}{{ defaultDes2 }}</p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="nullPost" style="padding-top: 150px;">
        <div class="null_ null_1">
          <img :src="codeUrl" alt="no" />
          <div class="nullTxt nullTxt1">
            {{ defaultInfo.name }}
          </div>
          <div class="nullTxt">
            {{ defaultDes1 + "，" + defaultDes2 }}
          </div>
        </div>
        <cube-button class="btn_">编辑信息</cube-button>
      </div>
    </div>

    <div class="null_" v-if="nullTemp">
      <img src="../../../assets/image/nsale/null.png" alt="null" />
      <div class="nullTxt">
        您还未创建任何团队模版，无法开设新账号 请先前往电脑端创建团队模版
      </div>
    </div>

    <div class="mask" v-if="cannotInvited">
      <div class="tips">{{ cannotInvitedText }}</div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import apiNsale from "@/utils/nsaleApi.js"
export default {
  data() {
    return {
      nullPost: false,
      nullTemp: false,
      cannotInvited: false, // 代理人是否被风控禁止邀新
      cannotInvitedText: "暂时不能邀请哦", // 禁止信息
      appId: "", //商城id
      bullTemp: "",
      tempInfo: {
        tempName: ""
      },
      inviteUrl: "",
      userId: "",
      identify: "",
      codeUrl: "",
      defaultInfo: {},
      defaultDes1: "交易、工具、团队",
      defaultDes2: "做保险用保思，人人都是BOSS！",
      column1: [
        // { text: "没有模板", value: "模版1号" },
        // { text: "模版2号", value: "模版2号" }
      ],
      list: []
    };
  },
  filters: {
    filterTeam(val) {
      if (val == "" || val == null) {
        return bullTemp;
      } else {
        return val;
      }
    }
  },
  mounted() {
    // alert(navigator.userAgent)
    this.getAppId();
    this.hideOptionMenu();
    this.userId = this.$route.query.userId;
    this.identify = this.$route.query.identify; //获取微信分享配置所需参数
    localStorage.setItem("i_", this.identify); //获取微信分享配置所需参数
    this.checkInvite()
    this.getToken().then(() => {
      this.getUserDetailByUserId();
      this.queryTemplateByUserId();
      this.queryDevelopTeamByUserId();
    });
  },
  methods: {
    getAppId() {
      //获取appid
      this.appId = this.$route.query.appId;
      localStorage.setItem("a_id", this.appId);
      if (this.appId != "wx6caf1ccf0fe9a167") {
        this.defaultDes1 = "青春还在";
        this.defaultDes2 = "梦想别等待，加入我们成就梦想。";
      }
    },
    // 禁止投保规则调用
    checkInvite() {
      const ruleCode = "202205278,20220805348"; // 生产
      // const ruleCode = "20220519913,20220812919"; // 测试
      const params = {
        cuswebuserid: this.userId,
        operate: "禁止-邀请下级",
        ruleCode,
      };
      apiNsale.verifyState(params).then((res) => {
        let { returnCode, data } = res.data;
        if (returnCode === "0000" && data == "1") {
          // 状态为1禁止邀新
          this.cannotInvited = true;
          this.cannotInvitedText = '账号异常，暂无操作权限';
        }
      });
    },
    verifyBSAppId() {
      //接口判断appid
      api.verifyBSAppId().then(res => {
        this.isBSApp = res.data.content;
        if (!this.isBSApp) {
          this.defaultDes1 = "青春还在";
          this.defaultDes2 = "梦想别等待，加入我们成就梦想。";
        }
      });
    },
    hideOptionMenu() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("hideOptionMenu");
        }
      );
    },
    showOptionMenu() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("showOptionMenu");
        }
      );
    },
    getUserDetailByUserId() {
      api.getUserDetailByUserId(this.userId).then(res => {
        this.defaultInfo = res.data.content;
      });
    },
    addAccount() {
      let urlArr = this.inviteUrl.split("/");
      let id = urlArr[urlArr.length - 1];
      console.log(urlArr);
      // this.$router.push({
      //   path: `/nsale/register/${id}?userId=${this.userId}`
      // });
      window.location.href =
        window.location.origin +
        `/m/nsale/register/${id}?userId=${this.userId}`;
    },
    getToken() {
      return api.getToken({ userId: this.userId }).then(res => {
        localStorage.setItem("token", res.data.content);
      });
    },
    getRegisterLink() {
      return api
        .getRegisterLink(this.tempInfo.id)
        .then(res => res.data)
        .then(data => {
          let { returnCode, returnMsg, content } = data;
          if (returnCode === "9999") {
            this.cannotInvited = true;
            this.cannotInvitedText = returnMsg;
            return false;
          }
          return data.content;
        })
        .then(url => {
          if (!url) {
            return;
          }
          this.inviteUrl = url;
          import("jr-qrcode").then(jrQrcode => {
            // 模块方法调用，传入字符串，获取 base64 编码的图片 URL
            var imgBase64 = jrQrcode.getQrBase64(url);
            this.codeUrl = imgBase64;
          });
        });
    },
    transformUrl(url) {
      console.log("url -> ", url);
      const pathname = new URL(url).pathname;
      // let origin = "http://mall.run4wd.com"; // 支持跨域的测试环境图片

      let origin = window.location.origin;
      const imgUrl = origin + pathname; // 转化后跨域的图片路径
      return imgUrl;
    },
    queryTemplateByUserId() {
      let data = {
        token: localStorage.getItem("token"),
        pageNum: 1,
        pageSize: 10000
      };
      api.queryTemplateByUserId(data).then(res => {
        if (!res.data.content.list || res.data.content.list.length == 0) {
          this.nullTemp = true;
          this.tempInfo.tempName = "没有模板";
        } else {
          this.column1 = res.data.content.list;
          this.tempInfo = res.data.content.list[0];
          this.getRegisterLink();
        }
      });
    },
    queryDevelopTeamByUserId() {
      let data = {
        appId: this.appId
      };
      api.queryDevelopTeamByUserId(data).then(res => {
        if (!res.data.content || res.data.content.length == 0) {
          this.nullPost = true;
        }
        this.list = res.data.content.map(item => {
          return {
            ...item,
            originalImageUrl: this.transformUrl(item.originalImageUrl)
          };
        });
      });
    },
    showTempPicker() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: "选择",
          alias: {
            value: "id",
            text: "tempName"
          },
          data: [this.column1],
          onSelect: this.selectHandle
        });
      }
      this.picker.show();
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      console.log(selectedVal, selectedIndex, selectedText);
      this.tempInfo = {
        tempName: selectedText[0],
        id: selectedVal[0]
      };
      this.getRegisterLink();
      console.log(this.tempInfo, "this.tempInfo");
    },
    toPreview(index, item) {
      this.$router.push({ path: `/nsale/preview/${this.tempInfo.id}` });
      this.setInfo(item);
    },
    setInfo(item) {
      let postInfo = {
        userId: this.userId,
        img: item.originalImageUrl,
        name: this.defaultInfo.name,
        des1: this.defaultDes1,
        des2: this.defaultDes2,
        qrcode: this.codeUrl
      };
      localStorage.setItem("postInfo", JSON.stringify(postInfo));
    }
  }
};
</script>

<style scoped lang="scss">
.nsale_ {
  background: rgba(245, 245, 245, 1);
  min-height: 100vh;
  position: relative;
  .btn_ {
    width: 305px;
    height: 50px;
    background: rgba(255, 74, 53, 1);
    border-radius: 5px;
    margin: 40px auto 10px;
  }
  .head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 60px;
    padding: 0 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .head_ {
      font-size: 15px;
      color: rgba(51, 51, 51, 1);
      position: relative;
      .i_img {
        position: absolute;
        right: 10px;
        top: 12px;
        height: 7px;
        width: auto;
      }
    }
    .head_2 {
      width: 160px;
      height: 30px;
      background: #f5f5f5;
      border-radius: 5px;
      display: flex;
      align-items: center;
    }
    .head_3 {
      width: 100px;
      height: 30px;
      line-height: 30px;
      background: rgba(255, 74, 53, 1);
      border-radius: 5px;
      font-size: 13px;
      color: rgba(255, 255, 255, 1);
    }
  }

  .list_ {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 8px;
    .item_ {
      width: 170px;
      margin-top: 10px;
      .item_1 {
        height: 243px;
        position: relative;
        .item_1img {
          width: 100%;
          height: 100%;
        }
        .saveTip {
          width: 100%;
          height: 20px;
          line-height: 20px;
          background: rgba(0, 0, 0, 1);
          opacity: 0.4;
          position: absolute;
          bottom: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 12px;
            color: rgba(255, 255, 255, 1);
            opacity: 0.5;
            // transform: scale(0.7, 0.7);
          }
        }
      }
      .item_2 {
        background: #fff;
        height: 56px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
        .scale {
          // transform: scale(0.7, 0.7);
          margin-left: 5px;
          width: 70%;
        }
        .item_2img {
          margin-left: 5px;
          width: 30%;
          height: auto;
        }
        .txt {
          text-align: left;
          font-size: 8px;
        }
        .txt1 {
          margin-bottom: 4px;
          font-weight: bold;
          font-size: 16px;
        }
        .txt2 {
          margin: 0 6px 0 0;
          line-height: 12px;
        }
      }
    }
  }

  .null_ {
    padding-top: 70px;
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
    img {
      height: 130px;
      width: auto;
    }
    .nullTxt {
      width: 246px;
      line-height: 20px;
      margin: 10px auto 0;
    }
  }
  .null_1 {
    margin: 0 auto;
    padding-top: 0;
    width: 345px;
    height: 345px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .nullTxt1 {
      font-size: 17px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }
}
.mask {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  .tips {
    height: 42px;
    padding: 0 25px;
    background: #373737;
    border-radius: 21px;
    line-height: 42px;
    text-align: center;
    font-size: 13px;
    color: #fff;
  }
}
</style>
